<div class="vtz-main-wrapper">
  <div class="vtz-main-container vtz-main-container--home">
    <div class="vtz-title-section vtz-title-section--blue">
      <app-header></app-header>
    </div>

    @if(electionOpen && aboutService.idUploadFlow){
      <main aria-label="form">
        @if(screenType === 'NEW') {
          <h1 id="main-title" class="vtz-h1" i18n>Create Password</h1>
          <p class="vtz-text vtz-text--wide vtz-text--center" i18n>Please create a password.</p>
        } @else {
          <h1 id="main-title" class="vtz-h1" i18n>Enter Password</h1>
          <p class="vtz-text vtz-text--wide vtz-text--center" i18n>Please enter your password.</p>
        }
        <form [formGroup]="loginForm" class="vtz-form">
          @for (field of fields; track field; let i = $index) {
            <div class="vtz-form__row">
              @switch (field.fieldType) {
                @case ('voter_id') {
                  <div class="vtz-form__item">
                    <label class="vtz-form__label" for="{{field.fieldName}}">
                      <span i18n="Form field label">{{ field.fieldTitle }}</span>
                    </label>
                    <input class="vtz-form__input vtz-form__input_disable" autocomplete="off" type="text"
                      id="{{ field.fieldName }}" readonly formControlName="{{ field.fieldName }}" name="{{ field.fieldName }}"
                      readonly="readonly" value="{{voter_id}}" [attr.aria-required]="field.isMandatory ? 'true' : null"
                      [attr.required]="field.isMandatory ? true : null" [attr.aria-label]="field.fieldTitle" [ngClass]="{ 'vtz-form__input--error': loginForm.controls[field.fieldName].dirty &&
                            loginForm.controls[field.fieldName].invalid}" />
                  </div>
                }
                @case('password'){
                  <div class="vtz-form__item">
                    <label class="vtz-form__label" for="{{field.fieldName}}">
                      <span i18n="Form field label">{{ field.fieldTitle }}</span>
                      @if (field.isMandatory) {
                        <span class="vtz--red">*</span>
                      }
                      @if (field.fieldTooltip !== undefined) {
                        <button id="tooltip-{{field.fieldName}}" class="vtz-tooltip"
                          matTooltip="{{field.fieldTooltip}}" i18n-matTooltip="Tooltip information" matTooltipPosition="after"
                          aria-label="Tooltip for input field "
                          i18n-aria-label="Explains to screen reader users what kind of element they are looking at"
                          (click)="onTooltipClick($event)"></button>
                      }
                    </label>
                    <div class="pin-special">
                      <input class="vtz-form__input" autocomplete="off" [type]="hide ? 'password' : 'text'" type="text"
                        id="{{ field.fieldName }}" formControlName="{{ field.fieldName }}" name="{{ field.fieldName }}"
                        [ngClass]="{ 'vtz-form__input--error': loginForm.controls[field.fieldName].dirty &&
                                    loginForm.controls[field.fieldName].invalid}" />
                      <mat-icon class="hide-show" aria-hidden="true" matSuffix (click)="hide = !hide">{{hide ? 'visibility_off'
                        : 'visibility'}}</mat-icon>
                    </div>
                    @if (
                      loginForm.controls[field.fieldName].touched &&
                      loginForm.controls[field.fieldName].errors?.required &&
                      field.isMandatory) {
                      <div role="alert">
                        <span class="vtz-form__error" aria-live="assertive" i18n="Invalid form field">{{ field.fieldTitle }} is required.
                        </span>
                      </div>
                    }
                  </div>
                }
                @case ('confirm_password') {
                  <div class="vtz-form__item">
                    <label class="vtz-form__label" for="{{field.fieldName}}">
                      <span i18n="Form field label">{{ field.fieldTitle }}</span>
                      @if (field.isMandatory) {
                        <span class="vtz--red">*</span>
                      }
                      @if (field.fieldTooltip !== undefined) {
                        <button id="tooltip-{{field.fieldName}}" class="vtz-tooltip"
                          matTooltip="{{field.fieldTooltip}}" i18n-matTooltip="Tooltip information" matTooltipPosition="after"
                          aria-label="Tooltip for input field "
                          i18n-aria-label="Explains to screen reader users what kind of element they are looking at"
                          (click)="onTooltipClick($event)"></button>
                      }
                    </label>
                    <div class="pin-special">
                      <input class="vtz-form__input" autocomplete="off" [type]="hide ? 'password' : 'text'" type="text"
                        id="{{ field.fieldName }}" formControlName="{{ field.fieldName }}" name="{{ field.fieldName }}"
                        [ngClass]="{ 'vtz-form__input--error': loginForm.controls[field.fieldName].dirty &&
                                    loginForm.controls[field.fieldName].invalid}" />
                      <mat-icon class="hide-show" aria-hidden="true" matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </div>
                    @if (
                      loginForm.controls[field.fieldName].touched &&
                      loginForm.controls[field.fieldName].errors?.required &&
                      field.isMandatory) {
                      <div role="alert">
                        <span class="vtz-form__error" aria-live="assertive" i18n="Invalid form field">{{ field.fieldTitle }} is required.
                        </span>
                      </div>
                    }
                    @if (
                      !loginForm.controls[field.fieldName].touched &&
                      loginForm.controls[field.fieldName].errors?.['PasswordNoMatch']) {
                      <div role="alert">
                        <span class="vtz-form__error" aria-live="assertive" i18n="Invalid form field">The passwords do not match.
                        </span>
                      </div>
                    }
                    @if (
                      loginForm.controls[field.fieldName].touched &&
                      loginForm.controls[field.fieldName].errors?.['PasswordNoMatch']) {
                      <div role="alert">
                        <span class="vtz-form__error" aria-live="assertive" i18n="Invalid form field">The passwords do not match. You can check the passwords by clicking on the eye icon.
                        </span>
                      </div>
                    }
                  </div>
                }
                @default {}
              }
            </div>
          }
          <div class="vtz-actions password-actions">
            <div class="button-group">
              <button class="button button-primary" [disabled]="loginForm.invalid || !electionOpen || sessionService.activeSessionCheck()" (click)="onSubmit()" i18n="Button label">SUBMIT</button>
            </div>
          </div>
          @if(screenType === 'NEW') {
            <div class="validation-hints">
              <h5 i18n>Password Rules:</h5>
              <div class="validation-item" [ngClass]="{
                  'text-danger': !passwordRequirements.hasUpperCase,
                  'text-success': passwordRequirements.hasUpperCase
                }" i18n>
                <span>{{ passwordRequirements.hasUpperCase ? '✓' : '✗' }}</span>
                Must have at least 1 upper case letter.
              </div>
              <div class="validation-item" [ngClass]="{
                'text-danger': !passwordRequirements.hasLowerCase,
                'text-success': passwordRequirements.hasLowerCase
                }" i18n>
                <span>{{ passwordRequirements.hasLowerCase ? '✓' : '✗' }}</span>
                Must have at least 1 lower case letter.
              </div>
              <div class="validation-item" [ngClass]="{
                'text-danger': !passwordRequirements.hasNumber,
                'text-success': passwordRequirements.hasNumber
                }" i18n>
                <span>{{ passwordRequirements.hasNumber ? '✓' : '✗' }}</span>
                Must have at least 1 number.
              </div>
              <div class="validation-item" [ngClass]="{
                'text-danger': !passwordRequirements.hasSpecialChar,
                'text-success': passwordRequirements.hasSpecialChar
                }" i18n>
                <span>{{ passwordRequirements.hasSpecialChar ? '✓' : '✗' }}</span>
                Must have at least 1 special character.
              </div>
              <div class="validation-item" [ngClass]="{
                'text-danger': !passwordRequirements.isValidLength,
                'text-success': passwordRequirements.isValidLength
                }" i18n>
                <span>{{ passwordRequirements.isValidLength ? '✓' : '✗' }}</span>
                Must have at least 12 characters.
              </div>
            </div>
          }
        </form>
        @if(screenType === 'CHECK' && electionOpen && aboutService.idUploadFlow && userService.userType === 'VWA_ID') {
          <div class="vtz-text vtz-text--center" style="margin-top: 25px;">
            <p i18n>Forgot your password? <strong><a style="cursor:pointer" class="vtz--red" (click)="forgotPassword()">Click here.</a></strong></p>
          </div>
        }
        @if (displaySpinner) {
          <div class="progressSpinner">
            <mat-spinner [diameter]="300" color="primary"></mat-spinner>
            <div class="spinner-warning">
              <p i18n>Please do not refresh, click the browser back button, or close your browser.</p>
            </div>
          </div>
        }
      </main>
    }
  </div>
</div>
<app-back-button-confirmation-modal>
</app-back-button-confirmation-modal>